import { MaintenanceWindowSchedulerController } from '../controller/MaintenanceWindowSchedulerController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MaintenanceWindowSchedulerSchema } from '../types';

export class MaintenanceWindowSchedulerWebComponent extends BaseWebComponentElement {
  public controller: MaintenanceWindowSchedulerController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowSchedulerController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  get hasImmediatelyOption(): boolean {
    return this.hasAttribute('data-has-immediately');
  }

  set hasImmediatelyOption(value: boolean) {
    if (value) {
      this.setAttribute('data-has-immediately', 'true');
    } else {
      this.removeAttribute('data-has-immediately');
    }
  }

  get disabled(): boolean {
    const attributeValue = this.getAttribute('disabled');
    return attributeValue !== null;
  }

  set disabled(value: boolean) {
    if (value) {
      this.setAttribute('disabled', 'true');
    } else {
      this.removeAttribute('disabled');
    }
    this.controller?.view.setDisabledInnerComponents(value);
  }

  get viewData(): MaintenanceWindowSchedulerSchema | any {
    const attributeValue = this.getAttribute('data-view-data');
    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  set viewData(value: MaintenanceWindowSchedulerSchema) {
    this.setAttribute('data-view-data', JSON.stringify(value));
    this.controller?.render();
  }

  public setTitle(value: string) {
    this.controller?.view.setTitle(value);
  }
}
